<template>
  <v-dialog :value="true" max-width="790" width="530" persistent>
    <v-card class="dialog-box">
      <v-card-title class="headline">
        {{ $t("PleaseSelectWorkspaceOpen") }}
      </v-card-title>

      <div class="pl-6">
        <treeselect
          @input="updateWorkspaceSelected"
          :options="workspaceOptions"
          style="margin-bottom: 10px"
        />
        <!-- <v-checkbox
          :label="$tc('OpenInNewTab')"
          v-model="newTab"
          color="accent"
          class="mt-1"
        /> -->
      </div>

      <v-card-actions class="pa-0 pt-2">
        <v-btn
          @click="$emit('close')"
          :ripple="false"
          class="secondary-button select-workspace-button"
        >
          <span style="color: black">{{ $t("Exit") }}</span>
        </v-btn>
        <v-btn
          @click="$emit('confirm', workspaceSelected, newTab)"
          :ripple="false"
          color="white--text"
          class="main-button select-workspace-button"
          :disabled="!workspaceSelected"
        >
          <span class="select-workspace-button-text">{{ $t("Confirm") }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SelectWorkspaceDialogBox",

  props: {
    /**
     * List of workspaces that contain the selected object
     */
    workspaceOptions: {
      type: Array,
      required: true
    },
    workspaces: {
      type: Array,
      required: true
    },
    /**
     * Coordinates of the selected object
     */
    objectCoordinate: {
      type: String,
    }
  },

  data() {
    return {
      /**
       * Workspace selected from workspaces list
       */
      workspaceSelected: null,
      newTab: false
    };
  },

  methods: {
    ...mapActions([
      "setCurrentWorkspace",
      "RESET_NETWORK_DIAGRAM_STATE",
      "centerObjectNetworkOnWorkspace"
    ]),

    /**
     * Normalizes the key-value pairs of each given list option.
     * @param {Object} node - option being normalized.
     * @returns {{id, label: (null|*|string)}}
     */
    normalizer(node) {
      return {
        id: node.wp_uuid,
        label: node.wp_label
      };
    },

    /**
     * Update selected workspace.
     * Whenever user changes workspace selection in treeselect
     * @param workspace
     */
    updateWorkspaceSelected(workspaceId) {
      this.workspaces.forEach(workspace => {
        if(workspace.wp_id === workspaceId){
          this.workspaceSelected = workspace;
        }
      });
    },
  }
};
</script>

<style scoped>
.select-workspace-button {
  border-radius: 2px;
  width: 100px;
  height: 32px !important;
}

.select-workspace-button-text {
  font: normal normal normal 12px/16px Segoe UI;
  color: #ffffff;
}

.secondary-button {
  border: 1px solid #707070;
  width: 110px;
  height: 32px !important;
}

.v-dialog__content >>> .v-dialog {
  overflow-y: unset !important;
}
</style>

<style>
#select-workspace-treeselect .vue-treeselect__control {
  border: 1px solid #707070;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/Content/SelectWorkspaceDialogBox.vue